import { configureStore } from '@reduxjs/toolkit';
import counterReducer from "./features/counter/counterSlice";
import enrollReducer from './features/enroll/enrollSlice';
import loginReducer from './features/login/loginSlice';
import fbReducer from './features/fb/fbSlice';

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    enroll: enrollReducer,
    login: loginReducer,
    fb: fbReducer
  },
});

// `RootState` and `AppDispatch` are not needed in plain JavaScript
